import mixins from 'vue-typed-mixins';
import { AxiosResponse } from 'axios';
import _ from 'lodash';

import { ErrorResponse, 部門Api, 部門ListItemResponse, 部門Request } from '@/openapi/user';

import AlertMixin from '@/mixins/AlertMixin';
import ListMixin from '@/entries/user/mixins/ListMixin';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';

import UserApiUtility from '@/classes/common/UserApiUtility';

const initialEdit部門 = (): 部門ListItemResponse => {
  return {
    pk: 0,
    c部門コード: '',
    c部門名: '',
    c備考: '',
  };
};

export default mixins(AlertMixin, ListMixin, RoutesMixin, 事業所Mixin).extend({
  name: 'P部門',

  data(): {
    api: 部門Api;
    部門s: 部門ListItemResponse[];
    edit部門: 部門ListItemResponse;
  } {
    return {
      api: UserApiUtility.ogApi(部門Api),
      部門s: [],
      edit部門: initialEdit部門(),
    };
  },

  computed: {
    canUpdate(): boolean {
      return this.edit部門.pk > 0;
    },
  },

  created(): void {
    this.$_load();
  },

  methods: {
    selectForEdit(v部門: 部門ListItemResponse): void {
      this.edit部門 = _.cloneDeep(v部門);
    },

    clearForm() {
      this.edit部門 = initialEdit部門();
    },

    async save(isNew: boolean): Promise<void> {
      const request: 部門Request = _.pick(this.edit部門, ['c部門コード', 'c部門名', 'c備考']);
      const response: AxiosResponse<void | ErrorResponse> = isNew
        ? await this.api.create部門(this.事業所.pk, request)
        : await this.api.update部門(this.edit部門.pk, request);

      if (this.isValidationErrorResponse(response)) return;
      this.$_clearAndLoad();
    },

    async remove(部門pk: number): Promise<void> {
      if (this.部門s.length === 1) {
        window.alert('部門を全部削除することはできません');
        return;
      }

      const isCancelOrError = await this.isCancelOrValidationErrorResponseToDelete(() => this.api.delete部門(部門pk));
      if (isCancelOrError) return;
      this.$_clearAndLoad();
    },

    async $_load(): Promise<void> {
      const response = await this.api.list部門(this.事業所.pk);
      this.部門s = response.data;
    },

    $_clearAndLoad() {
      this.clearForm();
      this.$_load();
    },
  },
});
